import React, { useState } from "react";
import { withRedux, priceToDollars, isMobileDevice } from "helpers";
import * as styles from "../../../newStyles.styles";
import QtyInput from "./CartUtil/QtyInput";
import styled, { css } from "react-emotion";
import WebIcon from "../../WebIcon";
import { useViewport } from "../../useViewPort";
import { Modal } from "@material-ui/core";
import ProductInfoModal from "../StoreWebComponent/StoreUtil/ProductInfoModal";

const isMob = isMobileDevice();

const FlexContainer = styled("div")`
  display: flex;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;

  @media only screen and (min-width: 1001px) {
    -ms-flex-direction: row;
    flex-direction: row;
  }

  @media only screen and (max-width: 1000px) {
    -ms-flex-direction: column;
    flex-direction: column;
  }
`;

const ConfirmSpan = styled("span")`
  color: #4caf50;
  opacity: ${(props) => (props.show ? "100%" : "0")};
  transition: opacity 0.5s ease-in-out;
`;

const inlineBlock = css`
  display: inline-block;
`;

const CartContainerLeft = styled("div")`
  flex: 1 1 0;
  @media only screen and (min-width: 1001px) {
    width: 60%;
    margin-right: 40px;
    margin-left: 7px;
  }
`;

const CartContainerRight = styled("div")`
  flex: 1 1 0;
  @media only screen and (min-width: 1001px) {
    width: 40%;
    margin: 24px 0 0 7px;
    max-width: 362px;
  }
`;

const label = css`
  line-height: 22px;
  font-size: 16px;
  font-weight: bold;
  -webkit-transition: height 0.3s ease-in;
  -moz-transition: height 0.3s ease-in;
  transition: height 0.3s ease-in;
  background: transparent;
`;

const productInfo = css`
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 0;
`;

const tableStyle = css`
  table-layout: fixed;
  width: 100%;
  font-size: 16px;
  margin-bottom: 35px;
  -webkit-transition: height 0.3s ease-in;
  -moz-transition: height 0.3s ease-in;
  transition: height 0.3s ease-in;
  background: transparent;
  border-collapse: separate;
  line-height: 22px;
  vertical-align: top;
  border-color: #eee;
`;

const tableRow = css`
  -webkit-transition: opacity 0.3s ease-in, height 0.3s ease-in;
  -moz-transition: opacity 0.3s ease-in, height 0.3s ease-in;
  transition: opacity 0.3s ease-in, height 0.3s ease-in;
  vertical-align: middle;
`;

const tableHead = css`
  text-align: left;
  color: black;
`;

const productsCol = css`
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  font-weight: 500;
  column-span: 10;
  @media only screen and (min-width: 768px) {
    min-width: 60%;
    display: table-cell;
    column-span: 10;
  }
`;

const priceCol = css`
  display: none;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  font-weight: 500;
  @media only screen and (min-width: 768px) {
    min-width: 94px;
    display: table-cell;
  }
`;

const qtyCol = css`
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  font-weight: 500;
  column-span: 10;
  @media only screen and (min-width: 768px) {
    column-span: 6;
  }
`;

const totalCol = css`
  text-align: right;
  display: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  @media only screen and (min-width: 768px) {
    display: table-cell;
  }
`;

const hideOnMobile = css`
  display: none;
  @media only screen and (min-width: 768px) {
    display: table-cell;
  }
`;

const showOnMobile = css`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const productCartWrap = css`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const cancelIconContainer = css`
  padding-right: 12px;
  display: none;
  @media only screen and (min-width: 768px) {
    display: block;
  }
`;

const paddedOnDesktop = css`
  @media only screen and (min-width: 768px) {
    padding-left: 25px;
  }
`;

const rightAlignOnMobile = css`
  @media only screen and (max-width: 768px) {
    text-align: right;
  }
`;
const centerAlignOnMobile = css`
  display: flex;
  @media only screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const EditButton = styled("span")`
  display: block;
  font-size: 0.875rem;
  border-bottom: ${(props) => "1px " + props.color + " solid"};
  display: inline-block;
  margin-top: 5px;
  color: #999;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
`;

const removeButton = css`
  display: block;
  border-bottom: 1px solid #ff8200;
  display: inline-block;
  margin-top: 5px;
  color: #999;
  font-weight: 600;
  text-decoration: none;
  font-size: 1.0625rem;
  cursor: pointer;
  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const productImage = css`
  width: 100px;
  height: 100px;
  object-fit: contain;
  vertical-align: top;
  outline: none;
`;

const tableResponsive = css`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const additionalComments = css`
  min-height: 120px;
  display: block;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 0;
  resize: vertical;
  outline: none;
  overflow: auto;
  margin: 1rem 0;
`;

const productTitle = css`
  padding-left: 12px;
  font-weight: 600;
  text-decoration: none;
  font-size: 1.0625rem;
  text-align: left;
  @media only screen and (max-width: 768px) {
    padding-left: 0px;
  }
`;

const flexWrap = css`
  display: flex;
  flex-wrap: wrap;
`;

const col12 = css`
  flex: 0 0 100%;
  max-width: 100%;
`;

const colmd6 = css`
  position: relative;
  width: 100%;
  @media (min-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

const totalWrap = css`
  @media only screen and (min-width: 768px) {
    text-align: right;
  }
`;

const total = css`
  margin: 0 0 1em;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 19px;
`;

const cartNotice = css`
  font-style: italic;
  font-size: 0.9375rem;
  margin-bottom: 35px;
  color: #bbb;
`;

const additionalItems = css`
  font-size: 0.9375rem;
  margin-bottom: 35px;
  color: #bbb;
  font-weight: normal;
`;

const WebButton = styled("button")`
  padding: 10px;
  width: 190px;
  border-radius: 4px;
  color: white;
  background: ${(props) => props.background};
  font-weight: bold;
  border: none;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  cursor: pointer;
`;

const removeAll = css`
  text-decoration: underline;
  font-size: 0.875rem/1.143;
  letter-spacing: 0.2px;
  cursor: pointer;
`;

function CartWebComponent(props) {
  const { cart, webStore, isAdmin } = props;
  const { width } = useViewport();

  const breakpoint = 620;

  const [inputValue, setInputValue] = useState(cart.customerAdditionalComments);

  const [activeEditItem, setActiveEditItem] = useState(null);

  const [showEditItem, setShowEditItem] = useState(false);
  const [show, setShow] = useState(false);

  const cartIsEmpty = cart.cartQty === 0;
  const readyForCheckout = !cartIsEmpty;

  // console.log("printing cart");
  // console.dir(cart.cartItems);

  const toggleEditItem = (itemToEdit, storeItem, idx) => {
    if (itemToEdit && storeItem) {
      // console.log("toggling to edit item...");
      setActiveEditItem({
        editItem: itemToEdit,
        storeItem: storeItem,
        idx: idx,
      });
    }
    setShowEditItem(!showEditItem);
  };

  // console.log("active edit item: ");
  // console.dir(activeEditItem);

  const renderEditItemModal = () => {
    if (!showEditItem || !activeEditItem) return null;
    // console.log("rendering edit item modal");

    return (
      <Modal
        open={showEditItem}
        onClose={toggleEditItem}
        disableBackdropClick={true}
        style={{
          width: isMob ? "95%" : "500px",
          marginLeft: "auto",
          marginRight: "auto",
          position: "fixed",
          top: "5%",
          bottom: "5%",
          overflowY: "auto",
        }}
      >
        <ProductInfoModal
          storeItem={activeEditItem.storeItem}
          storeColor={props.activeApp.view.navigation.navBarColor}
          toggleProductInfoModal={toggleEditItem}
          setShow={setShow}
          editItem={activeEditItem.editItem}
          editItemIdx={activeEditItem.idx}
        />
      </Modal>
    );
  };

  const removeFromCart = (cartItem, index) => {
    props.actions.removeFromCart(cartItem, index);
  };
  const clearCart = () => {
    props.actions.removeCart();
  };

  const getNumItemsAlreadyInCart = (storeItem, quantity) => {
    const { cartItems } = cart;
    if (!cartItems) props.actions.removeCart();
    const items = cartItems.filter(
      (item) => item.purchaseItemId === storeItem.id
    );
    let numItemsAlreadyInCart = 0;
    items.forEach((item) => {
      numItemsAlreadyInCart += item.quantity;
    });
    // console.log("store item id: " + storeItem.id);
    // console.log("got num of items in cart: " + numItemsAlreadyInCart);
    // because user is editing an existing item, we don't want to include this items quantity in total count
    numItemsAlreadyInCart -= quantity;
    return numItemsAlreadyInCart;
  };

  const getRemainingPurchaseInfo = (numOfItemsAlreadyInCart, storeItem) => {
    const {
      totalPurchasesByUser,
      maxPurchasesPerUser,
      numberOfTotalPurchases,
      maxPurchasesTotal,
    } = storeItem;
    let purchasesRemaining = null;
    let maxPurchasesReached = false;
    let soldOut = false;

    // because items might already be in cart, we should could those as "purchased"
    let totalEffectivePurchasesByUser =
      (totalPurchasesByUser ? totalPurchasesByUser : 0) +
      numOfItemsAlreadyInCart;

    // check if each user is limited to an amount
    if (maxPurchasesPerUser != null && maxPurchasesPerUser > 0) {
      // check if user has hit max
      if (totalEffectivePurchasesByUser >= maxPurchasesPerUser) {
        maxPurchasesReached = true;
        purchasesRemaining = 0;
      } else {
        // calculate how many purchases user has remaining
        purchasesRemaining =
          maxPurchasesPerUser - totalEffectivePurchasesByUser;
      }
    }

    let effectiveCurrentTotalPurchases =
      (numberOfTotalPurchases ? numberOfTotalPurchases : 0) +
      numOfItemsAlreadyInCart;

    if (maxPurchasesTotal != null) {
      // there is a max number of total purchases for this - display accordingly
      if (effectiveCurrentTotalPurchases >= maxPurchasesTotal) {
        maxPurchasesReached = true;
        soldOut = true;
      } else {
        let purchasesUntilMaxAllowed =
          maxPurchasesTotal - effectiveCurrentTotalPurchases;

        if (purchasesRemaining != null) {
          // figure out which value is less between this and user purchase logic above
          purchasesRemaining = Math.min(
            purchasesRemaining,
            purchasesUntilMaxAllowed
          );
        } else {
          // user purchases not specified, use this value only
          purchasesRemaining = purchasesUntilMaxAllowed;
        }
      }
    }
    // console.log("purchases remaining: " + purchasesRemaining);
    return { purchasesRemaining, maxPurchasesReached, soldOut };
  };

  const goToCheckout = () => {
    props.actions.setTemplate(props.activeApp.id, null);
    // console.log("going to checkout");
    if (isAdmin) {
      props.history.push({
        pathname: `/${props.activeApp.landingPagePath}/home?isAdmin=true`,
        state: { path: "checkout" },
      });
      return;
    }
    props.history.push({
      pathname: `/${props.activeApp.landingPagePath}/home`,
      state: { path: "checkout" },
    });
  };

  const renderCheckoutButton = () => {
    if (readyForCheckout) {
      return (
        <div>
          <WebButton
            onClick={goToCheckout}
            background={props.activeApp.view.navigation.navBarColor}
          >
            Proceed to Checkout
          </WebButton>
        </div>
      );
    }
  };

  const renderOrderSummary = () => {
    if (readyForCheckout) {
      return (
        <div className={colmd6 + " " + totalWrap}>
          {" "}
          <p className={total}>
            {priceToDollars(cart.clientCalculatedSubtotal)}
          </p>
          <div className={cartNotice}>
            Shipping & any additional costs calculated at checkout
          </div>
          {renderCheckoutButton()}
        </div>
      );
    }
  };

  const MobileQtyHeader = () => (
    <th colSpan={10} className={rightAlignOnMobile}>
      Quantity
    </th>
  );
  const DesktopQtyHeader = () => (
    <th colSpan={6} className={rightAlignOnMobile + " " + paddedOnDesktop}>
      Quantity
    </th>
  );

  const MobileQtyColumn = (props) => (
    <td colSpan={10} className={qtyCol}>
      <div className={centerAlignOnMobile}>{props.children}</div>
    </td>
  );

  const DesktopQtyColumn = (props) => (
    <td colSpan={6} className={qtyCol}>
      <div className={centerAlignOnMobile}>{props.children}</div>
    </td>
  );

  <td colSpan={6} className={qtyCol}></td>;

  const QtyColumnHeader = () => {
    return width < breakpoint ? <MobileQtyHeader /> : <DesktopQtyHeader />;
  };
  const QtyColumn = (props) => {
    return width < breakpoint ? (
      <MobileQtyColumn children={props.children} />
    ) : (
      <DesktopQtyColumn children={props.children} />
    );
  };

  const renderCartIsEmpty = () => {
    if (cartIsEmpty) {
      return (
        <div>
          <p>Your cart is currently empty.</p>
        </div>
      );
    }
  };

  const onChangeHandler = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    props.actions.updateAdditionalComments(newValue);
  };

  const renderAdditionalComments = () => {
    if (readyForCheckout) {
      return (
        <div className={col12 + " " + colmd6}>
          <div style={{ textAlign: "left" }}>
            <label className={label}>Additional Comments</label>
            <textarea
              className={additionalComments}
              onChange={onChangeHandler}
              value={inputValue}
            ></textarea>
          </div>
        </div>
      );
    }
  };

  const renderItems = () => {
    if (!cartIsEmpty)
      return (
        <div className={tableResponsive}>
          {/* <h2 className={itemsLabel}>Items</h2> */}
          <table className={tableStyle}>
            <colgroup>
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
            </colgroup>
            <thead className={tableHead}>
              <tr>
                <th colSpan={10}>Product</th>
                <th
                  colSpan={2}
                  className={hideOnMobile}
                  style={{ textAlign: "center" }}
                >
                  Price
                </th>
                <QtyColumnHeader />

                <th
                  colSpan={2}
                  className={hideOnMobile}
                  style={{ textAlign: "right" }}
                >
                  Total
                </th>
              </tr>
            </thead>
            {getProductRows()}
          </table>
          <div style={{ textAlign: "left", marginBottom: "10px" }}>
            <a className={removeAll} onClick={clearCart}>
              Remove all products
            </a>
          </div>
        </div>
      );
  };

  const getGroupFromStoreItem = (id, storeItem) => {
    let result = null;
    storeItem.additionalOptions.forEach((group) => {
      if (group.id === id && !group.retired) {
        result = group;
      }
    });

    return result;
  };

  const getItemNameFromGroup = (group, itemId) => {
    let name = null;

    group.additionalOptionsItems.forEach((item) => {
      if (item.id === itemId) {
        name = item.name;
      }
    });

    return name;
  };

  const renderAdditionalItems = (cartItem, storeItem) => {
    const items = {};
    // console.log("rendering addtional items...");
    // console.dir(cartItem);
    cartItem.additionalOptionSelections.forEach((group) => {
      const storeItemGroup = getGroupFromStoreItem(
        group.additionalOptionsGroupId,
        storeItem
      );
      items[storeItemGroup.title] = [];
      if (storeItemGroup != null) {
        group.additionalOptionItemSelections.forEach((item) => {
          const itemName = getItemNameFromGroup(
            storeItemGroup,
            item.selectedAdditionalItemId
          );

          items[storeItemGroup.title].push(itemName);
        });
      }
    });

    const strings = [];

    Object.keys(items).forEach(function eachKey(key) {
      const string = `${key}: ${items[key].join(", ")}`;
      strings.push(string);
    });

    return (
      <div>
        {strings.map((string) => {
          return (
            <span className={additionalItems}>
              {string}
              <br />
            </span>
          );
        })}
      </div>
    );
  };

  const getProductRows = () => {
    return (
      <tbody>
        {cart.cartItems.map((cartItem, index) => {
          // console.log("printing cart items");
          // console.dir(cartItem);
          // console.log("got index: " + index);
          const { purchaseItemId: idx, quantity, subtotal } = cartItem;
          const productFromStore = webStore[idx];
          if (!productFromStore || productFromStore === undefined) return null;
          // console.log("GOT PRODUCT FROM STORE");
          // console.dir(productFromStore);

          const purchaseItemInfo = getRemainingPurchaseInfo(
            getNumItemsAlreadyInCart(productFromStore, quantity),
            productFromStore
          );
          // console.dir(purchaseItemInfo);

          const { title, price, imageUrl } = productFromStore;
          const productSubtotal = price * quantity;
          return (
            <tr key={idx} className={tableRow}>
              <td colSpan={10} className={productsCol}>
                <div className={productCartWrap}>
                  <div
                    className={cancelIconContainer}
                    onClick={() => removeFromCart(cartItem, index)}
                  >
                    <WebIcon
                      iconName={"cancel"}
                      useColor={true}
                      size={"12px"}
                      hover={true}
                    />
                  </div>

                  {imageUrl ? (
                    <div>
                      <img src={imageUrl} className={productImage} />
                    </div>
                  ) : null}

                  <div className={productTitle}>
                    {" "}
                    {title}
                    <br />
                    <EditButton
                      color={props.activeApp.view.navigation.navBarColor}
                      onClick={() =>
                        toggleEditItem(cartItem, productFromStore, index)
                      }
                    >
                      Edit
                    </EditButton>
                    {renderAdditionalItems(cartItem, productFromStore)}
                    <span className={showOnMobile}>
                      {" "}
                      <br />({priceToDollars(subtotal)})
                    </span>
                    <br />
                    <span
                      className={removeButton}
                      onClick={() => removeFromCart(cartItem, index)}
                    >
                      {" "}
                      Remove
                    </span>
                  </div>
                </div>
              </td>
              <td
                colSpan={2}
                className={priceCol}
                style={{ textAlign: "center" }}
              >
                {priceToDollars(subtotal / quantity)}
              </td>
              <QtyColumn
                children={
                  <QtyInput
                    pid={idx}
                    value={quantity}
                    price={price}
                    cartItem={cartItem}
                    isInCart={true}
                    index={index}
                    purchaseItemInfo={purchaseItemInfo}
                  />
                }
              ></QtyColumn>

              <td colSpan={2} className={totalCol}>
                <div className={"productTotal"}>{priceToDollars(subtotal)}</div>
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };

  const renderCheckoutRow = () => {
    return (
      <div className={flexWrap}>
        {renderAdditionalComments()}
        {renderOrderSummary()}
      </div>
    );
  };

  return (
    <div>
      <styles.H3 style={{ margin: "0px", marginBottom: "20px" }}>
        Shopping Cart
      </styles.H3>

      {renderItems()}
      {renderCartIsEmpty()}
      {/* {renderOrderSummary()} */}
      {renderEditItemModal()}
      {renderCheckoutRow()}
    </div>
  );
}

export default withRedux(CartWebComponent);
